<div class="container">
    <div class="wrapper">
        <div class="row">

            <div class="col-sm-12 mb-2">
                <h1 class="pageTitle">{{pageTitle}}</h1>
                <div style="text-align: center;" [innerHTML]="access_page_sub_title"></div>
            </div>
            <!-- <app-notifications [notification]="'locations_page_notification_banner_parent'"></app-notifications>    -->
            <hr>

            <!-- <div class="row m-4">
            <div class="mr-4 location-card  width-100">
                <div class="card bg-light mb-4 height-200">
                    <div class="float-right width-100">
                        <button class="btn btn-primary btn-large" (click)="showLoginToggle()"
                            style="margin-right: 10%;">
                            Car / Pickup / Motorbike
                        </button>

                        <button class="btn btn-primary btn-large" (click)="showLoginToggle()">
                            Restricted vehicle: Van, Campervan, Motorhome, Over-height vehicle
                        </button>
                    </div>
                </div>
            </div>
          </div> -->

            <div class="col-sm-12 col-md-6 col-lg-6 mt-4 " *ngIf="showLogin">
                <div class="card bb-panel  ">


                    <form [formGroup]="loginForm" autocomplete="chrome-off" (ngSubmit)="onSubmit()" class="col-sm-12">
                        <div class="card-location-header">
                            <h4 class="text-dark"><strong>Login</strong></h4>
                        </div>
                        <div class="form-group">
                            <label tabindex="0" for="email">Email</label>
                            <input type="text" class="form-control" formControlName="email" tabindex="0" role="textbox"
                                id="email" (keydown.space)="$event.preventDefault();"
                                (keydown.spacebar)="$event.preventDefault();">
                            <div *ngIf="submitted && form.email.errors" class="invalid-feedback">
                                <div *ngIf="form.email.errors.required" role="alert" tabindex="0">Email is
                                    required</div>
                                <div *ngIf="form.email.errors.pattern" role="alert" tabindex="0">Email must be a
                                    valid email address
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label tabindex="0" for="password">Password</label>
                            <input [type]="hide ? 'password' : 'text'" type="password" class="form-control"
                                id="password" formControlName="password" tabindex="0" role="textbox">
                            <span class="eye-pos">
                                <mat-icon class="material-symbols-outlined eye" (click)="togglePasswordVisible()"
                                    *ngIf="hide">
                                    visibility_off
                                </mat-icon>
                                <mat-icon class="material-symbols-outlined eye" (click)="togglePasswordVisible()"
                                    *ngIf="!hide">
                                    visibility
                                </mat-icon>
                            </span>
                            <div *ngIf="submitted && form.password.errors" class="invalid-feedback">
                                <div *ngIf="form.password.errors.required" role="alert" tabindex="0">Password is
                                    required</div>
                            </div>
                        </div>

                        <button type="submit" class="btn btn-primary btn-max govuk-button button-sizer" role="button">
                            <span><span>{{'ACCESS.LOGIN' | translate}}</span>
                                <fa-icon [icon]="faChevronRight"></fa-icon>
                            </span>
                        </button>

                        <br>
                        <br>
                    </form>

                    <!-- <span class="govuk-error-message forgot-password col-sm-12" (click)="sendToReset()">Forgot
                        your
                        password?</span> -->
                    <!--(click)="forgotPasswordToggle()"-->

                    <!-- <form [formGroup]="resetPasswordForm" class="col-sm-12">
                        <fieldset *ngIf="forgotPassword" class="govuk-fieldset">
                            <br />
                            <input class="form-control" id="reset-email-form" name="reset-email-form" type="text"
                                autocomplete="email" placeholder="Enter email address" formControlName="resetemail"
                                tabindex="0" role="textbox">
                            <br />
                            <div *ngIf="resetSubmitted && resetForm.resetemail.errors">
                                <p *ngIf="resetForm.resetemail.errors.pattern" id="email-error"
                                    class="invalid-feedback">
                                    <span class="govuk-visually-hidden">Error:</span>
                                    {{'FORM.EMAIL_INVALID'
                                    |
                                    translate}}
                                </p>
                                <p *ngIf="resetForm.resetemail.errors.required" id="email-error"
                                    class="invalid-feedback">
                                    <span class="govuk-visually-hidden">Error:</span>
                                    {{'FORM.EMAIL_REQUIRED'
                                    |
                                    translate}}
                                </p>
                                <br />
                            </div>
                            <button class="btn btn-primary btn-max govuk-button button-sizer" data-module="govuk-button"
                                (click)="sendReset()">
                                <span><span>{{'ACCESS.SENDRESET' | translate}}</span>
                                    <fa-icon [icon]="faChevronRight"></fa-icon></span>
                            </button>
                            <br />

                            <span class="invalid-feedback forgot-password-success" *ngIf="resetSuccess">
                                <br />
                                <span>{{'ACCESS.EMAIL_RESET' | translate}}</span>
                            </span>
                        </fieldset>
                    </form> -->

                    <app-reset-password [selectedDepartment]="selectedDepartment"></app-reset-password>
                </div>
            </div>

            <div class="col-sm-12 col-md-6 col-lg-6 mt-4">
                <div class="summary card bb-panel ">
                    <div class="summary-content">
                        <button class="btn btn-primary btn-max govuk-button button-sizer" (click)="register()"
                            style="margin-right: 10%;">
                            <span><span>{{'ACCESS.REGISTER' | translate}}</span>
                                <fa-icon [icon]="faChevronRight"></fa-icon>
                            </span>
                        </button>
                        <br>
                        <br>
                        <button class="btn btn-primary btn-max govuk-button button-sizer" (click)="continueAsGuest()">
                            <span><span>{{'ACCESS.CONTINUE' | translate}}</span>
                                <fa-icon [icon]="faChevronRight"></fa-icon>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 
        <div class="row mt-4">
            <div class="col-6">
                <button type="button" class="btn btn-primary govuk-button button-sizer" (click)="routerGoBack()" title="Back"
                    aria-label="Back to location"><span>
                        <fa-icon [icon]="faChevronLeft"></fa-icon><span>{{'COMMON.BACK' | translate}}</span>
                    </span></button>
            </div>

        </div> -->
        <br>

    </div>
</div>